import { PX_PER_MIN } from "./timeGrid"

function snap15(m: number): number {
  return Math.round(m / 15) * 15
}

export function captureStartMin(offsetY: number, gridStartMin: number): number {
  return snap15(gridStartMin + Math.round(offsetY / PX_PER_MIN))
}
